import React, { useState, useEffect } from "react";
import { Container, Button } from "reactstrap";
import Login from "../auth/Login";
import { Link } from "react-router-dom";
import { RestartServer } from "services/api/department";
import { HomePageConst } from "utils/constant";

function HeroSection() {
  const [showLoginPage, setShowLoginPage] = useState(false);

  const handleClose = () => {
    setShowLoginPage(false);
  };
  useEffect(() => {
    const data = fetch(`https://lic-agent-api.onrender.com/api/v1/restart`);
    console.log("lic-agent-api data>>", data);

    const data1 = fetch(
      `https://emphasisetech-api.onrender.com/api/v1/restart`
    );
    console.log("emphasisetech-api data1>>", data1);

    const data3 = fetch(`https://emp-prod-apis.onrender.com/api/v1/restart`);
    console.log("emp-prod-apis data>>", data3);

    const data4 = fetch(`https://leadgen-api-58tl.onrender.com/api/v1/restart`);
    console.log("leadgen-api-58tl data>>", data4);

    const data5 = fetch(`https://left-right-api.onrender.com/api/v1/restart`);
    console.log("left-right-api data>>", data5);
  }, []);
  useEffect(() => {
    async function restartServer() {
      let res = await RestartServer();
      console.log(">>>>res", res);
    }
    restartServer();
  }, []);
  return (
    <>
      <section className="banner-area">
        <div className="banner-area-overlay start">
          <Container
            className="banner-content"
            data-aos="slide-right"
            data-aos-duration="1500"
          >
            <h1 className="">{`" ${HomePageConst.TAG_LINE} "`}</h1>
            <div className="text-center">
              <Link to="/about-page">
                <Button className="custom-btn signup-btn text-white">
                  About Us
                </Button>
              </Link>
              {/* <Button className="custom-btn signup-btn text-white" onClick={() => setShowLoginPage(true)} >Login</Button> */}
            </div>
          </Container>
        </div>
        {showLoginPage ? (
          <div className="login-area-overlay">
            <div className="text-right">
              <h4 className="pr-5 mt-4 closeBtn" onClick={handleClose}>
                X
              </h4>
              <Login />
            </div>
          </div>
        ) : null}
      </section>
    </>
  );
}

export default HeroSection;
